module.exports = __webpack_public_path__ + "img/jonathan-min.23a598b2.png";